import { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import type { Agent, Skill } from '@/types'
import { listAgentSkills } from '@/lib/api'
import { CardGrid, Card } from '@/components/ui/Card'
import { Badge } from '@/components/ui/Badge'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function AgentSkillsTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()
  const [skills, setSkills] = useState<Skill[]>([])

  useEffect(() => {
    listAgentSkills(agent.id).then(setSkills)
  }, [agent.id])

  return (
    <div>
      <PendingBackendNotice endpoint={`GET /agents/${agent.id}/skills`} />
      <CardGrid>
        {skills.map((skill) => (
          <Card key={skill.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
              <div style={{ fontSize: 14, fontWeight: 500 }}>{skill.name}</div>
              <Badge>{skill.skill_category}</Badge>
            </div>
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 8 }}>{skill.description}</p>
            <div className="mono" style={{ fontSize: 11 }}>{skill.id} · v{skill.version}</div>
          </Card>
        ))}
      </CardGrid>
    </div>
  )
}
